import { createContext, type ReactNode, useContext, useState } from 'react';

interface SidebarContextType {
	isOpen: boolean;
	toggle: () => void;
	close: () => void;
}

const SidebarContext = createContext<SidebarContextType | null>(null);

export function SidebarProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<SidebarContext.Provider
			value={{
				isOpen,
				toggle: () => setIsOpen((v) => !v),
				close: () => setIsOpen(false),
			}}
		>
			{children}
		</SidebarContext.Provider>
	);
}

export function useSidebar() {
	const ctx = useContext(SidebarContext);
	if (!ctx) throw new Error('useSidebar must be used within SidebarProvider');
	return ctx;
}
